"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.loadUsers = function (queryParameters) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_USERS
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getUsers(auth, queryParameters);
  });
};

exports.loadUser = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_USER,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getUser(auth, id);
  });
};

exports.createUser = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.CREATE_USER
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.postUser(auth, data);
  });
};

exports.updateUser = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_USER
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putUser(auth, data);
  });
};